import * as yup from 'yup'

const emailAddressSchema = yup
  .object({
    name: yup.string().optional(),
    address: yup.string().email().optional(),
  })
  .required()

const recipientSchema = yup
  .object({
    emailAddress: emailAddressSchema,
  })
  .required()

const flagSchema = yup
  .object({
    flagStatus: yup.string().oneOf(['notFlagged', 'complete', 'flagged']).optional(),
  })
  .required()

const bodySchema = yup
  .object({
    contentType: yup.string().oneOf(['html', 'text']).optional(),
    content: yup.string().optional(),
  })
  .required()

export const outlookMessageSchema = yup
  .object({
    '@odata.context': yup.string().url().optional(),
    '@odata.etag': yup.string().optional(),
    id: yup.string().optional(),
    createdDateTime: yup.string().datetime().optional(),
    lastModifiedDateTime: yup.string().datetime().optional(),
    changeKey: yup.string().optional(),
    categories: yup.array().of(yup.string()).optional(),
    receivedDateTime: yup.string().datetime().optional(),
    sentDateTime: yup.string().datetime().optional(),
    hasAttachments: yup.boolean().optional(),
    internetMessageId: yup.string().optional(),
    subject: yup.string().optional(),
    bodyPreview: yup.string().optional(),
    importance: yup.string().oneOf(['low', 'normal', 'high']).optional(),
    parentFolderId: yup.string().optional(),
    conversationId: yup.string().optional(),
    conversationIndex: yup.string().optional(),
    isDeliveryReceiptRequested: yup.boolean().nullable().optional(),
    isReadReceiptRequested: yup.boolean().optional(),
    isRead: yup.boolean().optional(),
    isDraft: yup.boolean().optional(),
    webLink: yup.string().url().optional(),
    inferenceClassification: yup.string().oneOf(['focused', 'other']).optional(),
    body: bodySchema,
    sender: recipientSchema,
    from: recipientSchema,
    toRecipients: yup.array().of(recipientSchema).required(),
    ccRecipients: yup.array().of(recipientSchema).required(),
    bccRecipients: yup.array().of(recipientSchema).required(),
    replyTo: yup.array().of(recipientSchema).optional(),
    flag: flagSchema,
  })
  .required()

export type OutlookMessageResponse = yup.InferType<typeof outlookMessageSchema>

const outlookFileAttachmentSchema = yup
  .object({
    '@odata.type': yup.string().required(),
    '@odata.mediaContentType': yup.string().required(),
    id: yup.string().required(),
    lastModifiedDateTime: yup.string().nullable().optional(),
    name: yup.string().nullable().optional(),
    contentType: yup.string().nullable().optional(),
    size: yup.number().nullable().optional(),
    isInline: yup.boolean().nullable().optional(),
    contentId: yup.string().nullable().optional(),
    contentLocation: yup.string().nullable().optional(),
    contentBytes: yup.string().required(),
  })
  .required()

export const outlookAttachmentsResponseSchema = yup
  .object({
    '@odata.context': yup.string().url().required(),
    value: yup.array().of(outlookFileAttachmentSchema).required(),
  })
  .required()

export type OutlookAttachmentsResponse = yup.InferType<typeof outlookAttachmentsResponseSchema>
